import { render } from "./ContextMenu.vue?vue&type=template&id=d7f2b650&scoped=true&ts=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=d7f2b650&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7f2b650"]])

export default __exports__